import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { EventServicesService } from 'src/app/services/event-services.service';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from 'xng-breadcrumb';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { JobServicesService } from 'src/app/services/job-services.service';
import { FeedbackFormComponent } from 'src/app/forms/feedback-form/feedback-form.component';
import { SocketService } from 'src/app/services/socket.service';

@Component({
    selector: 'jitsi-container',
    templateUrl: './jitsi-container.html',
    styleUrls: ['./jitsi-container.css'],
    providers: [MessageService],
    standalone: false
})

export class JitsiContaineComponent implements OnInit {
    public jitsiScriptPromise: Promise<any> | null = null;
    @ViewChild('feedbackForm') feedbackFormComponent!: FeedbackFormComponent;

    public interviewStarted: boolean = false;
    public jitsiAPI: any;
    public hmsRoomUrl: SafeResourceUrl | null = null;
    public currentProvider: string = '';
    public userId: any;
    public stageId: any;
    public eventId: any;
    public c_userName: any;
    public schoolId: any;
    public candidateEmail: any;
    public candidateName: any
    public showAddRole: boolean = false;
    public feedbackSlider: boolean = false;
    public paramItems: any;
    public roomName: string = '';
    public meetingEnd: boolean = false;
    public formUuid: string = '';
    meetingStatus: any;
    adminReload: boolean = false;
    assessmentScore: any = [];
    isLoading: boolean = false
    candidateDetails: any;
    headerCollapsed: boolean = false;
    hmsIframeLoading: boolean = false;
    candidateAssessmentDetails: any;
    userEventData: any;
    company_id: string = '';
    showBackNext: boolean = true;
    interviewId: any;
    feedbackMode: string = 'create';
    public recordButton: any;
    otherPanelMembersFeedback: any[] = [];
    panelMembers: any[] = [];
    selectedPanelMemberId: number | null = null;
    selectedPanelMemberFormId: number | null = null;
    loadingOtherFeedback: boolean = false;
    currentUserId: number | null = null;
    currentUserName: string = 'You';
    originalFeedbackMode: string = 'create';
    isViewOnlyFeedback: boolean = false;
    isLoadingResume: boolean = false;
    showCandidateDetailsSidebar: boolean = false;
    candidateInfoPayload: any = null;
    userPrivileges: Set<string> = new Set();

    constructor(private eventServices: EventServicesService,
        private activatedRoute: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,
        private globalService: GlobalServicesService,
        private messageService: MessageService,
        private jobService: JobServicesService,
        private socketService: SocketService,
        private sanitizer: DomSanitizer) { }

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHandler(event: any) {
        this.adminReload = true;
        return undefined;
    }

    ngOnInit(): void {
        this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
            this.userPrivileges = privileges;
        });
        this.isLoading = true;
        this.adminReload = false;
        let feedback_status: any = null;
        this.activatedRoute.queryParamMap.subscribe((param: any) => {
            this.userId = param.get('userID')
            this.interviewId = param.get('interviewId')
            this.eventId = param.get('eventId')
            this.c_userName = param.get('c_userName')
            this.schoolId = param.get('schoolId')
            this.stageId = param.get('stageId')
            this.paramItems = param.params;
            feedback_status = param.get('feedbackStatus')
        })

        if (feedback_status == 'Submitted') {
            this.feedbackMode = 'edit';
        } else {
            this.feedbackMode = 'create';
        }

        const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
        this.currentUserId = userDetails?.id != null ? Number(userDetails.id) : null;
        this.currentUserName = [userDetails?.first_name, userDetails?.last_name].filter(Boolean).join(' ') || userDetails?.name || 'You';

        this.globalService.userMeta$.subscribe(meta => {
            const profile = meta?.user_profile;
            if (profile?.id != null) {
                this.currentUserId = Number(profile.id);
                this.currentUserName = [profile.first_name, profile.last_name].filter(Boolean).join(' ') || profile.name || 'You';
            }
        });

        const companyDetails = JSON.parse(localStorage.getItem('company-details') || '{}');
        this.company_id = companyDetails?.company_metadata?.company_id || '';
        this.updateBreadcrumb();

        if (this.interviewId && this.userId) {
            const connectUserId = this.currentUserId ? this.currentUserId.toString() : 'admin_' + new Date().getTime();
            this.socketService.connect(this.interviewId, connectUserId);
            this.socketHandler();
        }

    this.jitsiScriptPromise = this.globalService.loadScript('script', 'https://meet.jit.si/external_api.js', 'text/javascript', 'jitsi-external-api');

    if (this.eventId && this.interviewId && this.userId) {
        forkJoin({
            candidate: this.jobService.getCandidateInfo(this.userId, this.eventId),
            adminJoin: this.eventServices.InterviewAdminJoinFastApi(this.eventId, this.interviewId),
            meetingToken: this.eventServices.getMeetingToken(this.c_userName, this.interviewId, false)
        }).subscribe({
            next: (results: any) => {
                const candidateResponse = results.candidate;
                this.candidateName = candidateResponse.body.candidate_name;
                this.candidateEmail = candidateResponse.body.candidate_email;
                this.candidateDetails = candidateResponse.body.candidate_details;
                if (this.candidateInfoPayload) {
                    this.candidateInfoPayload = {
                        ...this.candidateInfoPayload,
                        email: this.candidateDetails?.email_id || this.candidateEmail || this.candidateInfoPayload.email,
                        mobile_number: this.candidateDetails?.mobile_number || this.candidateInfoPayload.mobile_number,
                        photo: this.candidateDetails?.photo || this.candidateInfoPayload.photo,
                    };
                }

                    const adminResponse = results.adminJoin;
                this.userEventData = adminResponse.body.interview_details;
                this.userEventData["event_uuid"] = this.eventId;
                this.userEventData['candidateId'] = this.userId;
                this.userEventData['interview_uuid'] = this.userEventData.interview_uuid || this.userEventData.uuid || this.interviewId;
                this.userEventData['candidate_uuid'] = this.userEventData.candidate_uuid || this.userId;
                this.userEventData['stage_uuid'] = this.userEventData.stage_uuid || this.stageId;

                this.candidateInfoPayload = {
                    id: this.userId,
                    name: this.userEventData?.candidate_name || this.candidateName,
                    email: this.candidateDetails?.email_id || this.candidateEmail,
                    mobile_number: this.candidateDetails?.mobile_number,
                    photo: this.candidateDetails?.photo,
                    selectedEventId: this.eventId
                };

                this.candidateAssessmentDetails = adminResponse.body.scores;
                this.assessmentScore = adminResponse.body.scores;
                this.roomName = this.userEventData.room_name;
                this.formUuid = adminResponse.body.feedback_form;
                this.meetingStatus = this.userEventData.interview_status;
                this.isLoading = false;
                if (this.userEventData.interview_status == 'Completed') {
                    this.meetingEnd = true;
                } else {
                    const tokenData = results.meetingToken.body;
                    this.initiateCall(tokenData);
                }
            },
            error: (error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Unable to initialize interview details',
                });
                this.isLoading = false;
            }
        });
    } else {
        this.isLoading = false;
    }
        this.recordButton = document.getElementById('stopRecordingbut')
        this.recordButton.disabled = true
    }

    toggleFunction(op: any, event: any) {
        op.toggle(event);
    }

    public handleSectionTabNext() {
        let a: any = document.getElementById("score-container");
        a.scrollTo({
            behavior: "smooth",
        });
        a.style.transition = "all 0.5s";
        a.scrollLeft += 200;
    }

    public handleSectionTabBack() {
        let a: any = document.getElementById("score-container");
        a.scrollTo({
            behavior: "smooth",
        });
        a.style.transition = "all 0.5s";
        a.scrollLeft -= 200;
    }

    openFeedbackSlider() {
        this.panelMembers = [];
        this.otherPanelMembersFeedback = [];
        this.selectedPanelMemberId = null;
        this.selectedPanelMemberFormId = null;
        const meta = this.globalService.getCurrentUserMeta?.() ?? null;
        const profile = meta?.user_profile;
        if (profile?.id != null) {
            this.currentUserId = Number(profile.id);
            this.currentUserName = [profile.first_name, profile.last_name].filter(Boolean).join(' ') || profile.name || 'You';
        }
        if (this.currentUserId == null) {
            const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
            this.currentUserId = userDetails?.id != null ? Number(userDetails.id) : null;
            this.currentUserName = [userDetails?.first_name, userDetails?.last_name].filter(Boolean).join(' ') || userDetails?.name || 'You';
        }
        const interviewUuid = this.userEventData?.interview_uuid;
        if (!interviewUuid || !this.eventId || !this.userId) {
            this.feedbackSlider = true;
            return;
        }
        this.loadingOtherFeedback = true;
        this.eventServices.getFeedbackTestDetailsFastApi(this.eventId, this.userId).subscribe({
            next: (res: any) => {
                this.loadingOtherFeedback = false;
                const list = res?.body?.feedback_details || [];
                const forThisInterview = list.filter(
                    (f: any) => f.interview_uuid === interviewUuid
                );
                const currentUserIdNum = this.currentUserId != null ? Number(this.currentUserId) : null;
                this.otherPanelMembersFeedback = forThisInterview.filter(
                    (f: any) => Number(f.submitted_by_id) !== currentUserIdNum
                );
                this.panelMembers = forThisInterview.map((f: any) => ({
                    submitted_by_id: f.submitted_by_id,
                    submitted_by_name: f.submitted_by_name,
                    submitted_date: f.submitted_date,
                    form_id: f.form_id,
                    isVirtual: false
                }));
                const currentUserEntry = this.panelMembers.find(
                    (m: any) => currentUserIdNum != null && (Number(m.submitted_by_id) === currentUserIdNum || m.submitted_by_id == this.currentUserId)
                );
                if (!currentUserEntry) {
                    this.panelMembers.unshift({
                        submitted_by_id: this.currentUserId,
                        submitted_by_name: this.currentUserName,
                        submitted_date: null,
                        form_id: null,
                        isVirtual: true
                    });
                } else {
                    this.panelMembers.sort((a: any, b: any) => {
                        if (Number(a.submitted_by_id) === currentUserIdNum) return -1;
                        if (Number(b.submitted_by_id) === currentUserIdNum) return 1;
                        return 0;
                    });
                }
                const defaultMember = this.panelMembers.find((m: any) => Number(m.submitted_by_id) === currentUserIdNum || m.submitted_by_id == this.currentUserId) || this.panelMembers[0];
                this.selectedPanelMemberId = defaultMember?.submitted_by_id ?? null;
                this.selectedPanelMemberFormId = defaultMember?.form_id ?? null;
                this.userEventData = { ...this.userEventData, form_id: defaultMember?.form_id ?? undefined };
                this.originalFeedbackMode = this.feedbackMode;
                this.isViewOnlyFeedback = false;
                this.feedbackSlider = true;
                setTimeout(() => {
                    if (defaultMember?.isVirtual) {
                        this.feedbackFormComponent?.resetToCreateMode();
                    } else if (defaultMember?.form_id) {
                        this.feedbackFormComponent?.loadPanelMemberFeedback(defaultMember.form_id);
                    }
                }, 0);
            },
            error: () => {
                this.loadingOtherFeedback = false;
                this.feedbackSlider = true;
            }
        });
    }

    selectPanelMember(member: any) {
        if (this.selectedPanelMemberFormId === member.form_id && this.selectedPanelMemberId === member.submitted_by_id) return;
        this.selectedPanelMemberId = member.submitted_by_id;
        this.selectedPanelMemberFormId = member.isVirtual ? null : (member.form_id ?? null);
        this.userEventData = { ...this.userEventData, form_id: member.form_id ?? undefined };
        const isCurrentUser = this.isCurrentUser(member);
        if (member.isVirtual) {
            this.feedbackMode = 'create';
            this.isViewOnlyFeedback = false;
            this.feedbackFormComponent?.resetToCreateMode();
        } else {
            this.isViewOnlyFeedback = !isCurrentUser;
            this.feedbackMode = isCurrentUser ? this.originalFeedbackMode : 'view';
            if (member.form_id) {
                this.feedbackFormComponent?.loadPanelMemberFeedback(member.form_id);
            }
        }
    }

    isCurrentUser(member: any): boolean {
        if (this.currentUserId == null || member?.submitted_by_id == null) return false;
        return Number(member.submitted_by_id) === Number(this.currentUserId) || member.submitted_by_id == this.currentUserId;
    }

    getInitials(fullName: string): string {
        if (!fullName) return 'UN';
        const names = fullName.trim().split(' ').filter((n: string) => n.length > 0);
        if (names.length === 0) return 'UN';
        if (names.length === 1) return names[0].charAt(0).toUpperCase();
        return names[0].charAt(0).toUpperCase() + names[names.length - 1].charAt(0).toUpperCase();
    }

    getAvatarColor(name: string): string {
        const colors = [
            '#FF6B35', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57',
            '#FF9FF3', '#54A0FF', '#5F27CD', '#00D2D3', '#FF9F43',
            '#EE5A24', '#009432', '#0652DD', '#9980FA', '#833471',
            '#F79F1F', '#A3CB38', '#1289A7', '#D63031', '#74B9FF'
        ];
        if (!name) return colors[0];
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    }

    onCloseFeedbackSlider(success: boolean) {
        this.feedbackSlider = false;
        this.feedbackMode = 'edit';
        const url = new URL(window.location.href);
        url.searchParams.set('feedbackStatus', 'Submitted');
        window.history.replaceState({}, '', url);
    }

    onFeedbackDialogHide() {
        this.panelMembers = [];
        this.otherPanelMembersFeedback = [];
        this.selectedPanelMemberId = null;
        this.selectedPanelMemberFormId = null;
        this.isViewOnlyFeedback = false;
        if (this.feedbackFormComponent) {
            this.feedbackFormComponent.resetFormToOriginalState();
        }
    }

    updateBreadcrumb(): void {
        this.breadcrumbService.set('@interview', 'Interview');
    }

    private socketHandler() {
        this.socketService.messageReceived.subscribe((message: any) => {
            if (message && message.action === 'meetingEnd') {
                this.meetingStatus = 'meetingEnd';
                this.meetingEnd = true;
                this.feedbackSlider = true;
                this.interviewStarted = false;
                this.hmsRoomUrl = null;

                const jitsi_div: any = document.querySelector('#jaas-container');
                if (jitsi_div) {
                    jitsi_div.style.display = 'none';
                }
            }
        });
    }

    public async initiateCall(tokenData: any) {
        try {
                this.currentProvider = tokenData.provider || 'jitsi';

                if (this.currentProvider === 'hms') {
                    const roomCode = tokenData.room_code;
                    const subdomain = tokenData.hms_subdomain;
                    if (!roomCode || !subdomain) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to initialize the interview room.'
                        });
                        return;
                    }

                    const encodedName = encodeURIComponent(this.currentUserName || 'Admin');
                    let iframeUrl = `https://${subdomain}.app.100ms.live/meeting/${roomCode}?name=${encodedName}`;
                    this.hmsRoomUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
                    this.hmsIframeLoading = true;
                    this.interviewStarted = true;


                    const callInitPayload: any = {
                        message_type: "call_Initiated",
                        interview_id: this.interviewId,
                        user_id: this.userId,
                        staff_name: this.userId,
                    };
                    this.eventServices.sendMessageWSFastApi(callInitPayload).subscribe(res => { });

                } else {
                    if (this.jitsiScriptPromise) {
                        await this.jitsiScriptPromise;
                    } else {
                        await this.globalService.loadScript('script', 'https://meet.jit.si/external_api.js', 'text/javascript', 'jitsi-external-api');
                    }

                const jitsi_div: any = document.getElementById('jaas-container');
                jitsi_div.style.display = 'block';
                this.interviewStarted = true;
                this.jitsiAPI = new (window as any).JitsiMeetExternalAPI("8x8.vc", {
                    roomName: tokenData.room_identifier,
                    parentNode: document.querySelector('#jaas-container'),
                    configOverwrite: {
                        prejoinConfig: {
                            enabled: false
                        },
                        prejoinPageEnabled: false,
                        enableClosePage: true,
                        startWithAudioMuted: false,
                        startWithVideoMuted: false,
                        hideParticipantsStats: true,
                        hideConferenceSubject: true,
                        disableInviteFunctions: true,
                        disableLocalVideoFlip: true,
                        fileRecordingsEnabled: true,
                        liveStreamingEnabled: false,
                        localRecording: {
                            disable: false
                        },
                        hideRecordingLabel: false,
                        recording: {
                            enabled: true,
                            mode: 'file'
                        },
                        toolbarButtons: ['microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen',
                            'fodeviceselection', 'hangup', 'recording', 'etherpad', 'sharedvideo', 'settings',
                            'videoquality', 'filmstrip', 'security', 'tileview', 'chat']
                    },
                    interfaceConfigOverwrite: {
                        VIDEO_QUALITY_LABEL_DISABLED: true,
                        FILM_STRIP_MAX_HEIGHT: 0,
                        TOOLBAR_BUTTONS: [
                            'microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen',
                            'fodeviceselection', 'hangup', 'recording', 'etherpad', 'sharedvideo',
                            'settings', 'videoquality', 'filmstrip', 'security', 'tileview', 'chat'
                        ]
                    },
                    jwt: tokenData.jwt_token
                });

                    const screenStopPayload: any = {
                        message_type: "call_Initiated",
                        interview_id: this.interviewId,
                        user_id: this.userId,
                        staff_name: this.currentUserName,
                    }
                    this.eventServices.sendMessageWSFastApi(screenStopPayload).subscribe(res => { });

                setTimeout(() => {
                    this.jitsiAPI.executeCommand('startRecording', {
                        mode: 'file'
                    });
                    this.recordButton.disabled = false;
                }, 5000);

                this.jitsiAPI.addListener('videoConferenceStart', () => {
                    this.meetingStatus = 'InMeeting';
                    this.adminReload = false;
                });

                this.jitsiAPI.addListener('participantLeft', async () => {
                    // this.jitsiAPI.stopRecording('file');
                    // await this.jitsiAPI.executeCommand('toggleLobby', true);
                    // this.meetingStatus = 'meetingEnd';
                    this.adminReload = false;
                    // this.updateInterviewStatus();
                });

                    this.jitsiAPI.addListener('participantJoined', async () => {
                        try {
                            this.meetingStatus = 'InMeeting';
                            this.adminReload = false;
                            this.makeSound();
                        } catch (err) {
                            console.error('Error in conference:', err);
                        }
                    });

                    this.jitsiAPI.addListener('videoConferenceLeft', async () => {
                        if (!this.adminReload) {
                            this.meetingStatus = 'meetingEnd';
                            this.updateInterviewStatus();
                            this.jitsiAPI.stopRecording('file');
                            this.feedbackSlider = true;
                            this.meetingEnd = true;
                            const screenStopPayload: any = {
                                message_type: "call_finished",
                                interview_id: this.interviewId,
                                user_id: this.userId,
                                staff_name: this.currentUserName,
                                schoolId: this.schoolId
                            }
                            this.eventServices.sendMessageWSFastApi(screenStopPayload).subscribe(res => {
                            });
                        }
                        this.interviewStarted = false;
                        this.jitsiAPI.dispose();
                        this.jitsiAPI = undefined;
                        const jitsi_div: any = document.querySelector('#jaas-container');
                        if (jitsi_div) {
                            jitsi_div.style.display = 'none';
                        }
                    });
                }
        } catch (error) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to initialize the interview room. Please check your internet connection.'
            });
        }
    }

    public onHmsMeetingEnd() {
        if (!this.adminReload) {
            this.meetingStatus = 'meetingEnd';
            this.updateInterviewStatus('COMPLETED');
            this.feedbackSlider = true;
            this.meetingEnd = true;
            const callFinishedPayload: any = {
                message_type: "call_finished",
                interview_id: this.interviewId,
                user_id: this.userId,
                staff_name: this.currentUserName,
                schoolId: this.schoolId
            };
            this.eventServices.sendMessageWSFastApi(callFinishedPayload).subscribe(res => { });
        }
        this.interviewStarted = false;
        this.hmsRoomUrl = null;
        this.hmsIframeLoading = false;
    }

    public onHmsIframeLoaded() {
        this.hmsIframeLoading = false;
    }

    public openResume() {
        if (!this.userId || !this.eventId) return;
        this.isLoadingResume = true;
        this.jobService.getCandidateResume(this.eventId, this.userId).subscribe(
            (response: any) => {
                const res = response?.body ?? response;
                if (res && res.resume) {
                    const resumeUrl = res.resume.toString().trim();
                    window.open(resumeUrl, '_blank');
                } else if (this.candidateDetails?.resume_cv) {
                    window.open(this.candidateDetails.resume_cv, '_blank');
                }
                this.isLoadingResume = false;
            },
            (error: any) => {
                this.isLoadingResume = false;
                if (this.candidateDetails?.resume_cv) {
                    window.open(this.candidateDetails.resume_cv, '_blank');
                } else {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load resume document.' });
                }
            }
        );
    }

    public makeSound() {
        let audio = new Audio('../../../assets/audio/participant-joined-3.wav');
        audio.play();
    };

    public updateInterviewStatus(status: string = 'COMPLETED') {
        let payload: any = { "status": status };
        this.eventServices.adminUpdateInterviewStatusFastApi(payload, this.eventId, this.interviewId).subscribe({
            next: (response: any) => {
                const screenStopPayload: any = {
                    message_type: "meetingEnd",
                    interview_id: this.interviewId,
                    user_id: this.userId,
                    staff_name: this.currentUserName,
                }
                this.eventServices.sendMessageWSFastApi(screenStopPayload).subscribe(res => {
                });
            }
        });
    };

    isNumber(value: any) {
        return typeof value == 'number' ? true : false;
    }

    openCandidateDetailsSidebar() {
        this.showCandidateDetailsSidebar = true;
    }
}